export default function (props: any) {
    const { stroke = '#70706E' } = props;
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
            <path d="M15.5 9V24" stroke={stroke} strokeWidth="2" />
            <path d="M8 16.5H23" stroke={stroke} strokeWidth="2" />
        </svg>
    );
}
